import moment from "moment";
import { ORDER_STATUS, ORDER_STATUS_GROUPS } from "./orderStatus";
import {
  getDiscountStatusLabel,
  PAYMENT_MODE,
  PAYMENT_MODE_LABEL,
} from "./userType";
import { SERVICE_CATEGORY } from "./serviceCategory";

export const DRAWER_WIDTH = 288;
export const MINI_DRAWER_WIDTH = 84;
export const HEADER_HEIGHT = 72;
export const APP_DRAWER_WIDTH = 320;
export const GRID_SPACING = 3;

export const getFormattedDate = (date: any, format: any) => {
  const d = new Date(date);
  return moment(d).zone(0).format(format);
};

export const formateDate = (date: any) => {
  if (!date) return "N/A";
  const parsed = moment(date);
  if (!parsed.isValid()) return "N/A";
  return `${parsed.format("DD/MM/YYYY")}, ${parsed.format("hh:mm A")}`;
};
export const formateDateOfJoining = (date: any) => {
  return moment(date).format("DD/MM/YYYY");
}



/**
 * function to calculate age from dob string
 * @param dob
 */
export const calculateAge = (dob: string) => {
  var diff_ms = Date.now() - moment(dob).toDate().getTime();
  var age_dt = new Date(diff_ms);

  return `${Math.abs(age_dt.getUTCFullYear() - 1970)} Years`;
};

/**
 *
 * @param number to convert in compact number
 * @returns will return compacted number
 */
export const DataFormater = (number: number) => {
  if (Number.isInteger(number)) {
    if (number >= 1000000000) {
      return (number / 1000000000).toString() + "B";
    } else if (number >= 1000000) {
      return (number / 1000000).toString() + "M";
    } else if (number >= 1000) {
      return (number / 1000).toString() + "K";
    } else {
      return number.toString();
    }
  } else {
    if (number >= 1000000000) {
      return (number / 1000000000).toFixed(2).toString() + "B";
    } else if (number >= 1000000) {
      return (number / 1000000).toFixed(2).toString() + "M";
    } else if (number >= 1000) {
      return (number / 1000).toFixed(2).toString() + "K";
    } else {
      return number.toFixed(2).toString();
    }
  }
};

export const removeEmptyValues = (data: any) => {
  for (var propName in data) {
    if (!data[propName] || data[propName].length === 0) {
      delete data[propName];
    } else if (typeof data[propName] === "object") {
      removeEmptyValues(data[propName]);
    }
  }
  return data;
};

export const createQueryParams = (params: any) => {
  const newObj: any = {};
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      newObj[key] = value;
    }
  }
  return Object.entries(newObj)
    .map((e) => e.join("="))
    .join("&");
};


export const FOLDER = {
  PROFILE: 'PROFILE',
  USER_DOCUMENT: 'USER_DOCUMENT',
  VEHICLE_BRAND: 'VEHICLE_BRAND',//logo
  SERVICE: 'SERVICE', // service banner
  SERVICE_CATEGORY: 'SERVICE_CATEGORY',
  SERVICE_TOOLS: 'SERVICE_TOOLS',
  SERVICE_REQUIREMENTS: 'SERVICE_REQUIREMENTS',
}

export const ACCEPTED_VIDEO_TYPES = ["video/mp4", "video/mpeg"];
export const ACCEPTED_VIDEO_ACCEPT =
  ".mp4,.mpeg,.mpg,video/mp4,video/mpeg";
export const MAX_VIDEO_SIZE_MB = 100;
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif",
  "image/jpg",
];
export const ACCEPTED_IMAGE_ACCEPT =
  ".jpg,.jpeg,.png,.webp,.avif,image/jpeg,image/png,image/webp,image/avif,image/jpg";
export const MAX_IMAGE_SIZE_MB = 5;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export type FOLDER_TYPE = (typeof FOLDER)[keyof typeof FOLDER];

export const ORDER_STATUS_DATA = [
  { id: "-1", label: "All" },
  { id: `${ORDER_STATUS.ORDER_PLACED}`, label: "Un-assigned" },
  { id: `${ORDER_STATUS.REJECTED_BY_MERCHANT}`, label: "Rejected By Franchise" },
  { id: ORDER_STATUS_GROUPS.IN_PROGRESS, label: "In Progress" },
  { id: `${ORDER_STATUS.COMPLETED}`, label: "Order Completed" },
  { id: ORDER_STATUS_GROUPS.CANCELLED, label: "Cancelled" },
  { id: `${ORDER_STATUS.CANCELLED_BY_USER}`, label: "Cancelled By User" },
  {
    id: `${ORDER_STATUS.CANCELLED_BY_SERVICE_PARTNER}`,
    label: "Cancelled By Franchise",
  },
  { id: `${ORDER_STATUS.PAYMENT_DONE}`, label: "Payment Done" },
  { id: `${ORDER_STATUS.PAYMENT_FAILED}`, label: "Payment Failed" },
];

export const PAYMENT_DATA = [
  { id: "-1", label: "All" },
  {
    id: `${PAYMENT_MODE.COD_ONLINE}`,
    label: PAYMENT_MODE_LABEL[PAYMENT_MODE.COD_ONLINE],
  },
  { id: `${PAYMENT_MODE.ONLINE}`, label: PAYMENT_MODE_LABEL[PAYMENT_MODE.ONLINE] },
  {
    id: `${PAYMENT_MODE.COD_CASH}`,
    label: PAYMENT_MODE_LABEL[PAYMENT_MODE.COD_CASH],
  },
];

export const CATEGORY_DATA = [
  { id: "-1", label: "All" },
  { id: `${SERVICE_CATEGORY.CAR}`, label: "Car Cleaning" },
  { id: `${SERVICE_CATEGORY.BIKE}`, label: "Bike Cleaning" },
  { id: `${SERVICE_CATEGORY.SOFA}`, label: "Sofa Cleaning" },
  { id: `${SERVICE_CATEGORY.TANK}`, label: "Tank Cleaning" },
  { id: `${SERVICE_CATEGORY.CARPET}`, label: "Carpet Cleaning" },
];


export const emptyAddressFields = {
  addressId: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pincode: "",
  latitude: "",
  longitude: "",
};

export const INITIAL_VALUES: any = {
  userId: "",
  franchiseId: "",
  paymentMode: "",
  serviceCategory: "",
  serviceId: "",
  vechileId: "",
  vehicleRegNo: "",
  price: 0,
  discountValue: "",
  couponCode: "",
  couponId: "",
  isPercentage: false,
  isFlatDiscount: false,
  serviceTime: "",
  serviceDate: "",
  addressType: "",
  ...emptyAddressFields,
};

export const TAX_PERCENT = 18;

export const COUPON_TYPE = {
  GLOBAL: "global",
  SPECIFIC_CATEGORIES: "specificCategories",
} as const;

export type CouponTypeValue =
  (typeof COUPON_TYPE)[keyof typeof COUPON_TYPE];

export const COUPON_TYPE_LABEL: Record<CouponTypeValue, string> = {
  [COUPON_TYPE.GLOBAL]: "Global",
  [COUPON_TYPE.SPECIFIC_CATEGORIES]: "Specific Categories",
};

export enum COUPON_STATUS {
  ACTIVE = 0,
  INACTIVE = 1,
  EXPIRED = 2,
}

export const COUPON_TYPE_DATA = [
  { id: "-1", label: "All" },
  { id: COUPON_TYPE.GLOBAL, label: "Global" },
  {
    id: COUPON_TYPE.SPECIFIC_CATEGORIES,
    label: "Specific Categories",
  },
];

export const COUPON_STATUS_DATA = [
  { id: "-1", label: "All" },
  { id: `${COUPON_STATUS.ACTIVE}`, label: "Active" },
  { id: `${COUPON_STATUS.INACTIVE}`, label: "Inactive" },
  { id: `${COUPON_STATUS.EXPIRED}`, label: "Expired" },
];

export const COUPON_CATEGORY_OPTIONS = [
  { id: SERVICE_CATEGORY.CAR, label: "Car Cleaning" },
  { id: SERVICE_CATEGORY.BIKE, label: "Bike Cleaning" },
  { id: SERVICE_CATEGORY.SOFA, label: "Sofa Cleaning" },
  { id: SERVICE_CATEGORY.TANK, label: "Tank Cleaning" },
  { id: SERVICE_CATEGORY.CARPET, label: "Carpet Cleaning" },
];

export const ALL_COUPON_CATEGORIES = [
  SERVICE_CATEGORY.CAR,
  SERVICE_CATEGORY.BIKE,
  SERVICE_CATEGORY.SOFA,
  SERVICE_CATEGORY.TANK,
  SERVICE_CATEGORY.CARPET,
];

/** Attached unit dropdown on the coupon value field; `id` is the `isPercentage` flag as a string. */
export const COUPON_DISCOUNT_UNIT_OPTIONS = [
  { id: "true", symbol: "%", label: "Percentage (%)" },
  { id: "false", symbol: "₹", label: "Flat Amount (₹)" },
];

export const INITIAL_COUPON_VALUES: {
  couponCode: string;
  title: string;
  description: string;
  couponValue: string;
  isPercentage: boolean;
  couponLevelRedemption: string;
  userLevelRedemption: string;
  image: string;
  categories: number[];
  startTime: string;
  endTime: string;
  isDefault: boolean;
} = {
  couponCode: "",
  title: "",
  description: "",
  couponValue: "",
  isPercentage: false,
  couponLevelRedemption: "",
  userLevelRedemption: "",
  image: "",
  // Every category is selected by default (a "global" coupon).
  categories: [...ALL_COUPON_CATEGORIES],
  startTime: "",
  endTime: "",
  isDefault: false,
};

export const getCouponTypeLabel = (type?: string) =>
  type === COUPON_TYPE.GLOBAL || type === COUPON_TYPE.SPECIFIC_CATEGORIES
    ? COUPON_TYPE_LABEL[type]
    : "N/A";

export const getCouponStatusLabel = (status?: number | string) =>
  getDiscountStatusLabel(status);